import script from "./UiFormField.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./UiFormField.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiFormField.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./UiFormField.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./UiFormField.vue.scss?vue&type=style&index=0&id=172ee54d&lang=scss&module=true!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./UiFormField.vue?vue&type=style&index=0&id=172ee54d&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__